<template>
  <div class="flex justify-between items-center bg-ruby-red-5 border rounded-lg border-ruby-red-5 p-4 mb-2">
    <span class="font-bold">{{ label ?? 'Required' }}</span>
    <ButtonComponent
      label="Add"
      variant="secondary"
      @customClick="navigate"
    >
      <template #icon>
        <PlusIcon
          class="shrink-0"
          width="1.5em"
          height="1.5em" />
      </template>
    </ButtonComponent>
  </div>
</template>

<script setup lang="ts">
import ButtonComponent from '../ui-components/ButtonComponent.vue'
import PlusIcon from '../ui-components/icons/PlusIcon.vue'
import { useRouter } from 'vue-router'

const props = defineProps<{
  anchorLink: string
  scrollToId?: string
  label?: string
}>()

const router = useRouter()

async function navigate() {
  await router.push(props.anchorLink)

  if (props.scrollToId) {
    requestAnimationFrame(() => {
      const el = document.getElementById(props.scrollToId!)
      if (el) el.scrollIntoView({ behavior: 'smooth' })
    })
  }
}

</script>
